<template>
    <div>
        <p class="category-title mx-2 mb-1">{{training.name}}</p>

        <div class="my-3">
            <div class="row m-0 align-items-start">
                <div class="col-8 mb-3">
                    <Card class="p-4">
                        <p class="my-1 sub-heading">Description</p>
                        <p class="my-1 sub-text" v-html="training.description"></p>

                        <div class="mt-4">
                            <p class="my-3 sub-heading">Training Content</p>
                            <ContentListComponent
                                :dayTask="dayTask"
                                :index="index"
                                :lastIndex="lastIndex"
                                v-for="(dayTask, index) in training.trainingSessions"
                                :key="index"
                            />
                        </div>
                    </Card>
                </div>
                <div class="col-4 fixed-col">
                    <Card class="p-3 gap-3 m-0">
                        <img :src="training.trainingImg" v-if="training.trainingImg" class="course-img" />
                        <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ8Fb0JfnooRfkiWm-ZNiYcNVs0_pnHZCfdFqaDuaq2swumeP49LZdT4I0fovUIq7CbM0k&usqp=CAU" class="course-img"/>

                        <!-- 1280 x 720 -->
                        <div class="d-flex flex-column justify-content-start">
                            <p class="mt-3 mb-2 course-title">{{ training.name }}</p>
                            <!-- <p class="m-0 sub-heading">Duration: 2h</p> -->
                           <div class="d-flex justify-content-between"> <Badge
                                class="badge-rounded badge-rounded-grey-outline my-2"
                                :label="'Trainer: ' + training.trainer"
                            />
                             <Badge
                                class="badge-rounded badge-rounded-grey-outline my-2"
                                :label="'Available From: ' + formatDate(training.createdDate)"
                            /></div>
                            <Button
                                class="qb-btn qb-btn-primary-md my-3"
                                @onClick="handleEnrollment"
                                label="Enroll Training"
                            />
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Button from '../components/ButtonComponent.vue';
import Badge from '../components/BadgeComponent.vue';
import Card from '../components/CardComponent.vue';
import ContentListComponent from '../components/ContentListComponent.vue';

import { createNamespacedHelpers } from 'vuex';
const { mapActions: trainingMapActions, mapGetters: trainingMapGetters } = createNamespacedHelpers('Training');
const { mapActions: workSheetMapActions } = createNamespacedHelpers('WorkSheet');
const { mapGetters: AuthMapGetters } = createNamespacedHelpers('Auth');

export default {
    name: 'CatalogDescriptionPage',
    data() {
        return {
            name: 'monisha',
        };
    },
    components: {
        Card,
        Badge,
        Button,
        ContentListComponent,
    },
    computed: {
        ...AuthMapGetters({
            user: 'getUser',
        }),
        ...trainingMapGetters({
            training: 'getTraining',
        }),
    },
    methods: {
        ...trainingMapActions({
            getTrainingDetails: 'GET_TRAINING_BY_ID',
            enrollTraining: 'ENROLL_TRAINING',
        }),
        ...workSheetMapActions({
            checkTrainingEnrollmentForUser: 'CHECK_TRAINING_ENROLLMENT_FOR_USER',
        }),
        handleEnrollment() {
            this.enrollTraining({
                payload: { trainingId: this.$route.params.id, userId: this.user.userId },
                successCallback: ({ data }) => {
                    this.$router.push({ name: 'WorkSheetPage', params: { id: data.data } });
                },
                errorCallback: (err) => {
                    Vue.$toast.error(err.message);
                },
            });
        },
    },
    created() {
        this.getTrainingDetails(this.$route.params.id);
        this.checkTrainingEnrollmentForUser({
            payload: { trainingId: this.$route.params.id, userId: this.user.userId },
            successCallback: ({ data }) => {
                if (data.status === 'OK' && data.message === 'FOUND') {
                    this.$router.push({ name: 'WorkSheetPage', params: { id: data.data } });
                }
            },
            errorCallback: (err) => {
                Vue.$toast.error(err.message);
            },
        });
    },
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/color.scss';
@import '../assets/scss/font.scss';
@import '../assets/scss/field.scss';

.fa-users-rectangle {
    font-size: 30px;
    margin: auto;
}
.category-title {
    font-size: $font-size-xxl;
    font-weight: $font-weight-bold;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
}
.course-title {
    font-size: $font-size-xxl;
    font-weight: $font-weight-normal-2;
    color: $light-600;
}
.catalogue-card {
    border-radius: $field-border-radius;
    border: 1px solid $light-300;
}
.course-img {
    border-radius: $field-border-radius;
    background-color: $light-300;
    width: 100%;
}

.sub-heading {
    font-size: $font-size-lg;
    font-weight: $font-weight-bold;
    color: $light-500;
}

.sub-text {
    font-size: $font-size-lg;
    font-weight: $font-weight-normal-2;
    color: $light-600;
}

.fixed-col {
    position: sticky;
    top: 10%;
    z-index: 1;
}
</style>
